export default __webpack_public_path__ + "static/media/logo.22b54106.webp";